export enum FORM_NAME {
  CREATE_SURVEY = 'CREATE_SURVEY',
  UPDATE_SURVEY = 'UPDATE_SURVEY',
}
